import { REQUEST_LINEAL_CHANNELS, RECEIVE_LINEAL_CHANNELS } from "../actions/payway";

const initialState = [];

export function linealChannels(state = initialState, action) {
    switch (action.type) {
        case REQUEST_LINEAL_CHANNELS:
            return state;
        case RECEIVE_LINEAL_CHANNELS:
            return action.data;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/payway.js